module.exports = __webpack_public_path__ + "img/record.8698f48a.svg";